import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(updateLocale);
dayjs.extend(customParseFormat);
dayjs.updateLocale('en', {
  weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado']
});

const formatHour = (hour) => {
  let formatedHour = hour;

  if (hour.indexOf('pm') !== -1) {
    const rawHour = parseInt(hour.split(':')[0].replace('pm', '')) + 12;
    formatedHour = hour.split(':')[1] ? `${rawHour}:${hour.split(':')[1]}` : `${rawHour}pm`;
  }
  return parseFloat(formatedHour.replace(':', '.').replace('am', '').replace('pm', ''))
}

const getIfOpen = (date, cb, otherDays = []) => {
  const { day, startHour, endHour } = date;
  const callback = cb || function() {};

  if (!day && !otherDays.length) {
    callback('NotFound');
    return 'NotFound';
  } else if (!day && otherDays.length) {
    callback('Cerrado');
    return 'Cerrado';
  }

  if (day.toLowerCase() === dayjs(new Date()).format('dddd').toLowerCase()) {
    let currentHour = dayjs().format('HHmm');
    let formatedCurrentHour = parseFloat(`${currentHour.slice(0, 2)}.${currentHour.slice(2, 4)}`);

    if (formatedCurrentHour >= formatHour(startHour) && formatedCurrentHour <= formatHour(endHour)) {
      callback('Abierto');
      return 'Abierto';
    } else {
      callback('Cerrado');
      return 'Cerrado';
    }
  }
}

export default getIfOpen;
